module.exports = {["template-constructor-control-shape_color"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon noarrow" data-alt="Color" data-alt-pos="left" data-alt-offset="9"><div class="opacity-grid"></div><div class="color-circle"></div></div>\n\n	<div class="panel">\n	</div>\n\n';
}
return __p;
},}